/**
 * ODDFISH — Services pages (nav active state, AOS, strike reveals)
 * Strikes wipe when AOS reveals the title; scroll/IO catch rows below the fold.
 */
(function () {
  "use strict";

  if (window.oddfishServicesInit) return;
  window.oddfishServicesInit = true;

  var scrollBound = false;
  var SERVICES_OFFSET = 700;
  var DEFAULT_OFFSET = 50;
  var SERVICE_STRIKE_SELECTOR =
    "[id^='oddfish-service-rows-'] .strike, .services_wrapper .odd .strike, .services_wrapper .even .strike, .oddfish-services-page .odd .strike, .oddfish-services-page .even .strike";

  function initServicesNav() {
    var nav = document.querySelector(".oddfish-services-nav");
    if (!nav) return;

    var links = nav.querySelectorAll(".services_nav_inner a[href]");
    var path = window.location.pathname.replace(/\/+$/, "").toLowerCase();

    links.forEach(function (link) {
      var href = link.getAttribute("href");
      if (!href) return;
      var linkPath = href.split("#")[0].replace(/\/+$/, "").toLowerCase();
      link.classList.toggle("active", linkPath === path);
    });
  }

  function initAos() {
    function boot() {
      if (typeof AOS === "undefined") {
        document
          .querySelectorAll(".oddfish-services-page, .oddfish-services-nav, .oddfish-black-faq, .oddfish-footer-cta")
          .forEach(function (root) {
            root.classList.add("no-aos");
          });
        document.querySelectorAll(".oddfish-black-faq .faq_title.slide-left").forEach(function (item) {
          item.style.transform = "none";
        });
        return;
      }

      if (!window.oddfishAosInit) {
        window.oddfishAosInit = true;
        AOS.init({
          once: true,
          duration: 800,
          easing: "ease-out-cubic",
          offset: 120,
          disable: false
        });
      } else if (typeof AOS.refresh === "function") {
        AOS.refresh();
      }
    }

    if (typeof AOS !== "undefined") {
      boot();
    } else {
      window.addEventListener("load", boot, { once: true });
    }
  }

  function usesServicesScrollOffset() {
    return !!(
      document.querySelector(".oddfish-services-main") ||
      document.querySelector(".oddfish-services-page.services_wrapper") ||
      document.querySelector("[id^='oddfish-service-rows-']")
    );
  }

  function getScrollRevealOffset() {
    return usesServicesScrollOffset() ? SERVICES_OFFSET : DEFAULT_OFFSET;
  }

  function strikeAosReady(strike) {
    var aosParent = strike.closest("[data-aos]");
    if (!aosParent) return true;
    if (typeof AOS === "undefined") return true;
    if (aosParent.closest(".no-aos")) return true;
    return aosParent.classList.contains("aos-animate");
  }

  function strikePartiallyVisible(strike) {
    var rect = strike.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return rect.width > 0 && rect.height > 0 && rect.bottom > 16 && rect.top < vh - 16;
  }

  function applyStrikeVisible(strike) {
    if (!strike || strike.dataset.strikePlayed === "1") return;
    strike.classList.add("strike-visible");
    strike.dataset.strikePlayed = "1";
  }

  function tryRevealStrike(strike) {
    if (!strike || strike.dataset.strikePlayed === "1") return true;
    if (!strikePartiallyVisible(strike)) return false;
    if (!strikeAosReady(strike)) return false;
    applyStrikeVisible(strike);
    return true;
  }

  function observeServiceStrikes(root) {
    if (!("IntersectionObserver" in window)) return;

    var scope = root && root.querySelectorAll ? root : document;

    if (!window._oddfishServiceStrikeObserver) {
      window._oddfishServiceStrikeObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            if (tryRevealStrike(entry.target)) {
              window._oddfishServiceStrikeObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: "0px 0px -4% 0px" }
      );
    }

    scope.querySelectorAll(SERVICE_STRIKE_SELECTOR).forEach(function (strike) {
      if (strike.dataset.strikePlayed === "1" || strike.dataset.strikeObserved === "1") return;
      strike.dataset.strikeObserved = "1";
      window._oddfishServiceStrikeObserver.observe(strike);
    });
  }

  function bindAosStrikeSync() {
    if (window._oddfishServiceAosStrikeBound) return;
    window._oddfishServiceAosStrikeBound = true;

    document.addEventListener("aos:in", function (event) {
      var el = event.detail;
      if (!el || !el.querySelectorAll) return;
      el.querySelectorAll(".strike").forEach(tryRevealStrike);
    });

    if ("MutationObserver" in window) {
      var aosObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          var el = mutation.target;
          if (!el || !el.classList || !el.classList.contains("aos-animate")) return;
          el.querySelectorAll(".strike").forEach(tryRevealStrike);
        });
      });

      function watchAosNodes(root) {
        var scope = root && root.querySelectorAll ? root : document;
        scope.querySelectorAll("[data-aos]").forEach(function (node) {
          if (!node.querySelector(".strike")) return;
          if (node.dataset.oddfishAosStrikeWatch === "1") return;
          node.dataset.oddfishAosStrikeWatch = "1";

          if (node.classList.contains("aos-animate")) {
            node.querySelectorAll(".strike").forEach(tryRevealStrike);
          }

          aosObserver.observe(node, { attributes: true, attributeFilter: ["class"] });
        });
      }

      watchAosNodes(document);
      window._oddfishWatchAosStrikeNodes = watchAosNodes;
    }
  }

  function sectionReached(section, offset) {
    var windowBottom = window.scrollY + window.innerHeight;
    var rect = section.getBoundingClientRect();
    var sectionBottom = window.scrollY + rect.top + section.offsetHeight;

    if (windowBottom > sectionBottom - offset) return true;

    return rect.top < window.innerHeight * 0.9 && rect.bottom > 32;
  }

  function handleScrollReveal() {
    var offset = getScrollRevealOffset();

    document.querySelectorAll(".animate").forEach(function (section) {
      if (!sectionReached(section, offset)) return;

      if (!section.classList.contains("scrolled")) {
        section.classList.add("scrolled");
      }

      section.querySelectorAll(".strike").forEach(tryRevealStrike);
    });
  }

  function initScrollAnimations() {
    handleScrollReveal();

    if (scrollBound) return;
    scrollBound = true;

    var ticking = false;

    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            handleScrollReveal();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener("resize", handleScrollReveal, { passive: true });
  }

  function bootServicesPage(root) {
    initServicesNav();
    initAos();
    bindAosStrikeSync();
    observeServiceStrikes(root);
    if (typeof window._oddfishWatchAosStrikeNodes === "function") {
      window._oddfishWatchAosStrikeNodes(root);
    }
    initScrollAnimations();
  }

  function bootAll() {
    bootServicesPage(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootAll);
  } else {
    bootAll();
  }

  window.addEventListener(
    "load",
    function () {
      initAos();
      observeServiceStrikes(document);
      if (typeof window._oddfishWatchAosStrikeNodes === "function") {
        window._oddfishWatchAosStrikeNodes(document);
      }
      handleScrollReveal();
    },
    { once: true }
  );

  document.addEventListener("shopify:section:load", function (event) {
    var scope = event.target;
    scope.querySelectorAll(".strike").forEach(function (strike) {
      strike.classList.remove("strike-visible");
      delete strike.dataset.strikePlayed;
      delete strike.dataset.strikeObserved;
    });
    scope.querySelectorAll(".animate").forEach(function (section) {
      section.classList.remove("scrolled");
    });
    initServicesNav();
    initAos();
    observeServiceStrikes(scope);
    if (typeof window._oddfishWatchAosStrikeNodes === "function") {
      window._oddfishWatchAosStrikeNodes(scope);
    }
    handleScrollReveal();
  });

  window.oddfishServicesScrollReveal = handleScrollReveal;
})();
